import React from 'react';
import { ITableFooterProps } from './Interfaces';
import PagingButton from './PagingButton';

const TableFooter: React.FC<ITableFooterProps> = ({ colInfos, totalRows, totalFilteredRows, startRow, endRow, currentPage, totalPages, totalFilteredPages, pageSize, changePageNumber, changePageSize }) => {

    let colSpan = 0
    colInfos.forEach((colInfo) => {
        if (colInfo.visible !== false) {
            colSpan += 1
        }
    });

    if (endRow > totalFilteredRows)
        endRow = totalFilteredRows - 1;

    if (totalFilteredRows == 0)
        return null

    return (<tr>
        <td colSpan={colSpan}>
            <div style={{ verticalAlign: 'middle' }}>
                <div className='pull-left' style={{ marginTop: 10, marginLeft: 8 }}>
                    Show row {(startRow + 1).toLocaleString()}-{(endRow).toLocaleString()} of {totalFilteredRows.toLocaleString()} rows.
                </div>
                <div className='pull-left' style={{ margin: 2 }}>
                    {totalFilteredPages > 1 && (
                        <>
                            <PagingButton text='<<' pageNumber={1} changePageNumber={changePageNumber} key='first' disabled={currentPage <= 1} />
                            <PagingButton text='<' pageNumber={currentPage - 1} changePageNumber={changePageNumber} key='previous' disabled={currentPage <= 1} />
                            {currentPage > 4 && currentPage == totalFilteredPages && <PagingButton pageNumber={currentPage - 4} changePageNumber={changePageNumber} key={currentPage - 4} />}
                            {currentPage > 3 && currentPage >= totalFilteredPages - 1 && <PagingButton pageNumber={currentPage - 3} changePageNumber={changePageNumber} key={currentPage - 3} />}
                            {currentPage > 2 && <PagingButton pageNumber={currentPage - 2} changePageNumber={changePageNumber} key={currentPage - 2} />}
                            {currentPage > 1 && <PagingButton pageNumber={currentPage - 1} changePageNumber={changePageNumber} key={currentPage - 1} />}
                            <PagingButton pageNumber={currentPage} changePageNumber={changePageNumber} key={currentPage} disabled={false} isCurrentPage={true} />
                            {currentPage < totalFilteredPages && <PagingButton pageNumber={currentPage + 1} changePageNumber={changePageNumber} key={currentPage + 1} />}
                            {currentPage < totalFilteredPages - 1 && <PagingButton pageNumber={currentPage + 2} changePageNumber={changePageNumber} key={currentPage + 2} />}
                            {currentPage <= 2 && currentPage < totalFilteredPages - 2 && <PagingButton pageNumber={currentPage + 3} changePageNumber={changePageNumber} key={currentPage + 3} />}
                            {currentPage <= 1 && currentPage < totalFilteredPages - 3 && <PagingButton pageNumber={currentPage + 4} changePageNumber={changePageNumber} key={currentPage + 4} />}
                            <PagingButton text='>' pageNumber={currentPage + 1} changePageNumber={changePageNumber} key='next' disabled={currentPage >= totalFilteredPages} />
                            <PagingButton text='>>' pageNumber={totalFilteredPages} changePageNumber={changePageNumber} key='last' disabled={currentPage >= totalFilteredPages} />
                        </>
                    )}
                </div>
                <div className='pull-right' style={{ marginTop: 10, marginRight: 8 }}>
                    Page {currentPage} of {totalFilteredPages.toLocaleString()} pages.
                </div>
            </div>
        </td>
    </tr>);
}
export default TableFooter;